<template>
    <b-modal title="Miscellaneous Events"
             size="lg"
             class="font-weight-bold"
             centered
             no-close-on-backdrop
             v-model="dialogOpen"
             @hidden="onDialogHidden">
        <!--this binds the enter key to the insert event, i.e. makes the OK button the default button-->
        <vue-keypress key-event="keydown" :key-code="13" @success="handleEnterKey"></vue-keypress>

        <vue-keypress key-event="keydown" :key-code="66" :modifiers="['altKey']" :preventDefault="true" @success="pageBreakBefore = !pageBreakBefore"></vue-keypress>
        <vue-keypress key-event="keydown" :key-code="65" :modifiers="['altKey']" :preventDefault="true" @success="pageBreakAfter = !pageBreakAfter"></vue-keypress>

        <b-alert v-model="showErrors" variant="danger" dismissible>
            <div v-for="(error, index) in currentErrors" :key="index">
                <p>{{ error }}</p>
            </div>
        </b-alert>

        <div>

            <b-row class="mt-3">

                <b-col cols="8">

                    <b-textarea label="Text" id="eventText" v-model="eventText" rows="11" placeholder="Please enter event text here" autofocus>

                    </b-textarea>

                </b-col>

                <b-col ref="inputFields">

                    <b-form-group label="Document Spacing Settings" class="ml-1">
                        <b-form-group label-cols
                                      content-cols="4"
                                      content-cols-md="3"
                                      content-cols-lg="2"
                                      label="Page break before (Alt+B)"
                                      label-for="pageBreakBefore">
                            <b-form-checkbox name="pageBreakBefore" v-model="pageBreakBefore" switch class="pt-2"></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols
                                      content-cols="4"
                                      content-cols-md="3"
                                      content-cols-lg="2"
                                      label="Page break after (Alt+A)"
                                      label-for="pageBreakAfter">
                            <b-form-checkbox name="pageBreakAfter" v-model="pageBreakAfter" switch class="pt-2"></b-form-checkbox>
                        </b-form-group>
                        <b-form-group label-cols
                                      content-cols="5"
                                      content-cols-md="4"
                                      content-cols-lg="3"
                                      label="Empty lines before"
                                      label-for="emptyLinesBefore">
                            <b-form-input name="emptyLinesBefore" type="number" min="0" max="5" v-model="emptyLinesBefore" />
                        </b-form-group>
                        <b-form-group label-cols
                                      content-cols="5"
                                      content-cols-md="4"
                                      content-cols-lg="3"
                                      label="Empty lines after"
                                      label-for="emptyLinesAfter">
                            <b-form-input name="emptyLinesAfter" type="number" min="0" max="5" v-model="emptyLinesAfter" />
                        </b-form-group>
                    </b-form-group>

                    <b-form-group label="Time">
                        <b-form-input name="eventTime"
                                      v-model="eventTime"
                                      type="time">
                        </b-form-input>
                    </b-form-group>

                </b-col>


            </b-row>



        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="danger" @click="reset">Reset</b-button>
            <b-button @click="cancel">Cancel</b-button>
            <b-button variant="success" @click="insert">OK</b-button>
        </template>
    </b-modal>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import VueKeypress from 'vue-keypress';
    import { v4 as newUuid } from 'uuid';

    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import InputMixin from '../../mixins/InputMixin';
    import EventsMixin from '../../mixins/EventsMixin';

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeMiscellaneousEventDialog',
        mixins: [DateTimeMixin, InputMixin, EventsMixin],
        components: {
            'vue-keypress': VueKeypress
        },
        model: {
            event: 'change',
            prop: 'active',

        },
        props: {
            configuration: {
                type: Object,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            mode: {
                type: String,
                default: 'insert',
                validator: function (value) {
                    // The value must match one of these strings
                    return (['insert', 'edit'].indexOf(value) !== -1);
                }
            },
            currentEditorSection: {
                default: null
            }
        },
        data: function () {
            return {
                dialogOpen: this.active,
                currentConfiguration: this.configuration,
                currentErrors: null,
                showErrors: false,
                
                sectionsInsertedEventData: null,

                eventText: null,
                pageBreakBefore: false,
                pageBreakAfter: false,
                emptyLinesBefore: 1,
                emptyLinesAfter: 1,
                eventTime: null
            }
        },
        watch: {
            configuration: function () {
                this.currentConfiguration = this.configuration;
            },
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.currentErrors = null;
                    if (this.mode == 'edit') {
                        try {
                            var base64EncodedMetaData = $(this.currentEditorSection).data('metadata');
                            var metaData = JSON.parse(atob(base64EncodedMetaData));
                            this.eventText = metaData.EventText;
                            this.pageBreakBefore = metaData.PageBreakBefore;
                            this.pageBreakAfter = metaData.PageBreakAfter;
                            this.emptyLinesBefore = metaData.EmptyLinesBefore;
                            this.emptyLinesAfter = metaData.EmptyLinesAfter;
                            this.eventTime = (metaData.Time == null) ? null : this.formatDateTime(metaData.Time, 'HH:mm', true, true);
                        }
                        catch
                        {
                            console.warn('invalid metadata in section');
                        }
                    } else {
                        this.reset();
                    }
                    this.sectionsInsertedEventData = null;
                }
                this.dialogOpen = this.active;
            },
            currentErrors: function () {
                this.showErrors = (this.currentErrors != null) && (this.currentErrors.length > 0);
            }
        },
        methods: {
            handleEnterKey: function (e) {
                if (this.isEventTargetWithinElement(e.event, this.$refs.inputFields)) {
                    this.insert();
                }
            },
            reset: function () {
                this.currentErrors = null;
                this.eventText = null;
                this.pageBreakBefore = false;
                if (this.currentConfiguration && this.currentConfiguration.DefaultPageBreakBefore) this.pageBreakBefore = true;
                this.pageBreakAfter = false;
                if (this.currentConfiguration && this.currentConfiguration.DefaultPageBreakAfter) this.pageBreakAfter = true;
                this.emptyLinesBefore = 1;
                if (this.currentConfiguration && (typeof this.currentConfiguration.DefaultEmptyLinesBefore != "undefined")) this.emptyLinesBefore = this.currentConfiguration.DefaultEmptyLinesBefore;
                this.emptyLinesAfter = 1;
                if (this.currentConfiguration && (typeof this.currentConfiguration.DefaultEmptyLinesAfter != "undefined")) this.emptyLinesAfter = this.currentConfiguration.DefaultEmptyLinesAfter;
                this.eventTime = null;
            },
            insert: function () {
                this.currentErrors = []
                if ((this.eventText == null) || (this.eventText == '')) {
                    this.currentErrors.push('Please enter event text in the text area');
                }
                if (this.currentErrors.length == 0) {               
                    var time = ((this.eventTime == null) || (this.eventTime.trim().length == 0)) ? null : this.parseDateTime(this.eventTime, 'HH:mm', true, true);
                    var metaData = {
                        SectionId: newUuid(),
                        Type: 'miscevent',
                        EventText: this.eventText,
                        PageBreakBefore: this.pageBreakBefore,
                        PageBreakAfter: this.pageBreakAfter,
                        EmptyLinesBefore: parseInt(this.emptyLinesBefore),
                        EmptyLinesAfter: parseInt(this.emptyLinesAfter),
                        Time: ((this.eventTime == null) || (this.eventTime.trim().length == 0)) ? null : this.parseDateTime(this.eventTime, 'HH:mm', true, true)
                    }

                    var content = this.eventText.replace(/(?:\r\n|\r|\n)/g, '<br>');
                    if (time != null)
                        content += ' AT ' + this.formatDateTime(time, 'h:mmA', true, true);
                    
                    var base64EncodedMetaData = btoa(JSON.stringify(metaData));
                    this.$emit('beforeSectionsInsertOrUpdate');
                    Vue.nextTick(() => {
                        var eventSection =
                            $('<div data-type="miscevent"/>')
                                .attr('id', metaData.SectionId)
                                .attr('data-metadata', base64EncodedMetaData)
                                .html(content)
                                .attr('data-content', content)
                                .data('content', content)
                                .insertAfter(this.currentEditorSection)[0];
                        if (this.mode == 'edit') {
                            $(this.currentEditorSection).remove(); //remove the old section
                        }
                        this.sectionsInsertedEventData = { sections: [eventSection] };
                        this.dialogOpen = false;
                    });
                }
            },
            onDialogHidden: function () {
                this.reset();
                this.$emit('change', false);
                if (this.sectionsInsertedEventData) {
                    this.$emit('sectionsInserted', this.sectionsInsertedEventData);
                } else {
                    this.$emit('cancelled');
                }
                this.sectionsInsertedEventData = null;
            }
        }
    }
</script>

